import { PaymentMethodsEnum } from '../../../../../views/phone-answering/constants';

export default {
  options: {
    [PaymentMethodsEnum.Cash]: 'Efectivo',
    [PaymentMethodsEnum.Online]: 'En línea',
    [PaymentMethodsEnum.InStoreCard]: 'Tarjeta en tienda',
  },
};
